/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const PrevIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="none"
    >
      <path
        d="M10.4879 17.4949C10.8159 17.175 11 16.7422 11 16.2911C11 15.84 10.8159 15.4072 10.4879 15.0873L4.25412 8.95731L10.4879 2.91269C10.8159 2.59276 11 2.15999 11 1.70888C11 1.25778 10.8159 0.825007 10.4879 0.505082C10.3242 0.345039 10.1295 0.218008 9.91487 0.13132C9.70028 0.0446312 9.47011 1.82437e-08 9.23764 2.10159e-08C9.00518 2.3788e-08 8.77501 0.0446312 8.56042 0.13132C8.34583 0.218008 8.15107 0.345039 7.98736 0.505082L0.520888 7.74497C0.355836 7.90371 0.224831 8.09256 0.135429 8.30064C0.0460282 8.50872 -8.49547e-07 8.7319 -8.46859e-07 8.95731C-8.44171e-07 9.18272 0.0460282 9.40591 0.135429 9.61398C0.224831 9.82206 0.355836 10.0109 0.520888 10.1697L7.98736 17.4949C8.15107 17.655 8.34583 17.782 8.56042 17.8687C8.77501 17.9554 9.00518 18 9.23764 18C9.47011 18 9.70028 17.9554 9.91487 17.8687C10.1295 17.782 10.3242 17.655 10.4879 17.4949Z"
        fill="white"
      />
    </svg>
  )
}
